import React, { useState, useEffect } from 'react'
import "./UserProfile.css";
import ProfileSidebar from './ProfileSidebar';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import api from '../../../services/api';
import APP_CONFIG from '../../../config/appConfig';
import useAuth from '../../../hooks/useAuth';
import { Form, Button } from 'react-bootstrap';
import { useUser } from '../../../context/UserContext';
import ScreenLoader from '../../HtmlElements/ScreenLoader';
import Alert from '../../HtmlElements/Alert';
import { useConfig } from '../../../context/AppConfigContext';
import { getUrlDetailsObj, getUserStatsObject, recordActivity } from '../../../services/commonService';

export default function UserProfile() {
  useAuth();
  const { user } = useUser();
  var currentUrl = useLocation().pathname;
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState('');
  // const [image, setImage] = useState('');
  var pageParsedData = getUrlDetailsObj(useLocation, useParams);

  const [formData, setFormData] = useState({
    firstname: user?.firstname || '',
    lastname: user?.lastname || '',
    designation: user?.designation || '',
    company_name: user?.company_name || '',
    country: user?.country || ''
  });

  const navigate = useNavigate();
  const { userId } = useParams();
  const {appConfig} = useConfig();

  useEffect(() => {
      setLoader(true);

      setFormData({
        company_name: user?.company_name || '',
        country: user?.country || '',
        firstname: user?.firstname || '',
        lastname: user?.lastname || '',
        designation: user?.designation || ''
      });

      setLoader(false);

      const userStat = getUserStatsObject("Onboarding", "onboarding_basic_info", "Data: Basic Information", currentUrl);
      pageParsedData.page_params = {
        "tab": 'profile'
      }
      userStat.url_details = pageParsedData;
      recordActivity(userStat);
      
  }, [userId]);

  if(!appConfig){
    return <div> </div>;
  }
  const countryOptions = appConfig.country_options;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Clear the error for the current field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
    // console.log(formData);    
  }

  // const onImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setImage(URL.createObjectURL(file));
  //   }
  // }

  const validateForm = () => {
    let newErrors = {};

    if (!formData.firstname){
      newErrors.firstname = 'First Name is required';
    }else if(/[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(formData.firstname)){
      newErrors.firstname = 'Special characters are not allowed in First Name';
    }

    if (!formData.lastname){
      newErrors.lastname = 'Last Name is required';
    }else if(/[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(formData.lastname)){
      newErrors.lastname = 'Special characters are not allowed in Last Name';
    }

    if(formData.designation && /[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(formData.designation)){
      newErrors.designation = 'Special characters are not allowed in Designation';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCancel = () => {
    const userStat = getUserStatsObject("Onboarding", "cancel", "Data: Basic Information", currentUrl);
    recordActivity(userStat);
    navigate('/dashboard');
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    const formattedData = {
      // id: userId,
      // profileImage: image,
      firstname: formData.firstname,
      lastname: formData.lastname,
      designation: formData.designation,
      company_name: formData.company_name,      
      country: formData.country
    };

    setLoader(true);    

    try {
      // if(userId){
      //   formattedData.id = userId;
      //   delete(formattedData.password)
      // }

      if(formattedData.password){
        delete(formattedData.password);
      }

      const response = await api.post('/users/update_user_info', formattedData);
      if (response.data.status === 201 || response.data.status === 200) {
          
          sessionStorage.setItem('successMessage', response.data.result.message);

          if(user?.role_key === "CLIENT_EMPLOYEE"){
            navigate('/user_profile/company_profile');
          }else{
            navigate('/user_profile/business_segment');
          }

      } else {
            setApiError(response.data.result.message || 'An error occurred while saving the user.');
      }
    } catch (error) {
      const errorMsg = error.response?.data?.message || 'An error occurred while saving the user.';
      setApiError(errorMsg);
      console.error('Error saving user:', error);
    }
    setLoader(false);
  }

  return (
    <div className='user_profile_wrapper'>
      {loader === true && (<ScreenLoader />)}
      <div className='container'>
        <div className='user_profile_subblock'>
          {apiError && <Alert type="danger" message={apiError} />}
          <div className='row'>
            <div className='client_head_left'>
              <h5 className="client_head">Client admin login</h5>
            </div>
            <div className='col-md-3'>
              <div className='sidebar_profile'>
                <ProfileSidebar/>
              </div>
            </div>
            <div className='col-md-9'>
              <div className='userprofile_right'>
                <div className='row'>
                  <div className="col-md-12">
                      <Form onSubmit={handleSubmit} className="user_form_info" autoComplete='off'>
                        <div className='row'>
                          <div className='col-md-12'>
                            <div className='user_profile_change mb-3'>
                                <div className='img_profile_block'>
                                  {/* <img src="/img/user_profile.png" className="profile_picture" alt="profile"/> */}
                                  <img
                                    className="profile_picture"
                                    src={APP_CONFIG.AVATAR_URL + "background=0D8ABC&color=fff&name=" + user?.firstname + " " + user?.lastname + '&rounded=true&bold=true&font-size=0.50'}
                                    alt="icon" 
                                  />
                                </div>
                                <div className='upload_img'>
                                  {/* <Form.Control
                                    type="file"
                                    name="profileImage"
                                    className="upload_input"
                                    value={formData.profileImage}
                                    onChange={onImageChange}
                                  >
                                  </Form.Control>
                                  <a href="#0" className="upload_anchor">
                                  <i className="fa fa-camera" aria-hidden="true"></i> Upload Image
                                  </a> */}
                                </div>
                            </div>
                          </div>
                          <div className='col-md-6'>
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="firstname"
                                className="form-input"
                                style={{marginLeft : '5px'}}
                                value={formData.firstname}
                                onChange={handleChange}
                              >
                              </Form.Control>
                              <Form.Label className='form-label'>First name</Form.Label>
                              {errors.firstname && <div className="text-danger custom_error_msg">{errors.firstname}</div>}
                            </div>                            
                          </div>
                          <div className='col-md-6'>
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="company_name"
                                className="form-input"
                                style={{marginLeft : '5px'}}
                                value={formData.company_name}
                                disabled='disabled'
                              ></Form.Control>
                              <Form.Label className='form-label'>Company name</Form.Label>
                            </div>
                          </div>
                          <div className='col-md-6'>
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="lastname"
                                className="form-input"
                                style={{marginLeft : '5px'}}
                                value={formData.lastname}
                                onChange={handleChange}
                              >
                              </Form.Control>
                              <Form.Label className='form-label'>Last name</Form.Label>
                              {errors.lastname && <div className="text-danger custom_error_msg">{errors.lastname}</div>}
                            </div>
                          </div>
                          <div className='col-md-6'>
                            <div className="form-control-info">                              
                              <Form.Control
                                className="form-input"
                                as="select"
                                name="country"
                                style={{paddingLeft : '15px'}}
                                value={formData.country}
                                onChange={handleChange}>
                                <option key="" value="">Select Country</option>
                                {Object.keys(countryOptions).map((key) => (
                                  <option key={`country-${key}`} value={key}>{countryOptions[key]}</option>
                                ))}
                              </Form.Control>
                              <Form.Label className='form-label'>Country</Form.Label>

                            </div>
                          </div>
                          <div className='col-md-6'>
                          <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="designation"
                                className="form-input"
                                style={{marginLeft : '5px'}}
                                value={formData.designation}
                                onChange={handleChange}
                              ></Form.Control>
                              <label htmlFor="text" className="form-label">Department </label>
                              {errors.designation && <div className="text-danger custom_error_msg">{errors.designation}</div>}
                            </div>
                          </div>
                          <div className='col-md-6'>

                          </div>
                          <div className='col-md-6'>
                               
                          </div>
                        </div>

                        <div className='col-md-12 mt-4'>
                          <div className='prev_next_block'>
                            <Button type='button' onClick={handleCancel} className="previous_btn mr-2">
                              Cancel
                            </Button>
                            <Button type='submit' className="next_btn_blue">
                              Next
                            </Button>
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
              </div>  
            </div>  
          </div>      
        </div>
      </div>
    </div>
  )
}
